import { render, staticRenderFns } from "./EscolheOpcao.vue?vue&type=template&id=0d473e92&scoped=true"
import script from "./EscolheOpcao.vue?vue&type=script&lang=js"
export * from "./EscolheOpcao.vue?vue&type=script&lang=js"
import style0 from "./EscolheOpcao.vue?vue&type=style&index=0&id=0d473e92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d473e92",
  null
  
)

export default component.exports